/** ==========================================================
 * Diretiva para permitir inserir somente números e letras em um input
 * =========================================================== */
const validateCharacters = (e) => {
  if (e.key.search(/[^a-zA-Z0-9]/g) > -1) {
    e.preventDefault()
    return false
  }

  return true
}

const OnlyAlphaNumericDirective = {
  bind(el) {
    const input = el.querySelector('input')

    input.addEventListener('keypress', validateCharacters)
  },

  unbind(el) {
    el.querySelector('input').removeEventListener(
      'keypress',
      validateCharacters
    )
  }
}

export default OnlyAlphaNumericDirective
